module.exports = __webpack_public_path__ + "img/sop1.b8f01cc7.jpg";